import { ReactComponent as ArrowUpIcon } from '../../../../assets/images/iconsv2/arrow-up.svg';

import React, { PureComponent } from 'react';
import actions from 'core/redux/features/filters/actions';
import { connect } from 'react-redux';
import { AppState } from 'core/redux/reducers';
import {
  createSelectTagFilterOptionsByCategory,
  selectAllGroupTags,
  TagGroup,
} from 'core/redux/features/filters/categories/reducers';
import { ActiveFiltersType } from 'core/redux/features/filters/types';
import { ICategory } from 'core/redux/features/filters/categories/types';
// import { hot } from 'react-hot-loader/root'
import MultiSelectBox from 'Components/Elements/Buttons/MultiSelectBox';
import { voidCallback } from 'core/utils';
import FilterItem from './FilterItem';
import { selectTranslator } from 'core/redux/features/languages/trans';

const mapStateToProps = (state: AppState, props) => {
  const selectTags = createSelectTagFilterOptionsByCategory();
  return () => ({
    tags: selectTags(state, props.category.id),
    // activeFilters: state.filters.activeFilters,
    deviceType: state.deviceType,
    trans: selectTranslator(state),
    tagGroup: selectAllGroupTags(state),
  });
};

const mapDispatchToProps = {
  onSelectTags: actions.selectTags,
  onToggleTag: actions.toggleTag,
};

interface IOwnProps {
  parentRef: React.RefObject<HTMLElement>;
  activeFilters: ActiveFiltersType;
  tagGroup: TagGroup[];
  category: ICategory;
  onClose?: () => void;
  isActiveDropdown: boolean;
  onClickField: () => void;
  onSave?: (tags: number[]) => void;
}

type TProps = IOwnProps &
  ReturnType<ReturnType<typeof mapStateToProps>> &
  typeof mapDispatchToProps;

class FilterTagsComponent extends PureComponent<TProps, { tags: number[] }> {
  static defaultProps = {
    onClose: voidCallback,
  };
  state = {
    tags: [],
  };

  render() {
    const {
      props: {
        deviceType,
        tags,
        category,
        parentRef,
        onClose,
        isActiveDropdown,
        activeFilters,
        onClickField,
        trans,
      },
    } = this;

    const totalFilter = activeFilters.tags
      .filter((id, i) => activeFilters.tags.indexOf(id) === i)
      .filter(id => category.tags.indexOf(id) > -1).length;

    let namePrefix = '';
    if (totalFilter > 0) {
      namePrefix = ` (${totalFilter} ${trans('selected')})`;
    }

    return (
      <FilterItem
        onClick={() => onClickField()}
        name="filter-tags"
        isOpen={isActiveDropdown}
      >
        <MultiSelectBox
          onClose={() => {
            if (onClose) {
              onClose();
            }
          }}
          onSave={this.onSaveTags}
          parentRef={parentRef}
          name={category.name + namePrefix}
          options={tags}
          id="tags"
          selectedOptions={activeFilters.tags}
          isActiveDropdown={isActiveDropdown}
        />
        {deviceType === 'mobile' ? null : (
          <ArrowUpIcon className="dropdown-content-arrow" />
        )}
      </FilterItem>
    );
  }

  private onSaveTags = (tags: number[] | string[]) => {
    const { onSelectTags, onSave, activeFilters, category } = this.props;
    const otherTags = activeFilters.tags.filter(
      t => category.tags.indexOf(t) === -1,
    );

    const newTags = [...otherTags, ...tags] as number[];
    onSelectTags(newTags);
    if (onSave) {
      onSave(newTags);
    }

    // if (onClose) {
    //   onClose()
    // }
  };
}

// const FilterTagsRoot =
//   process.env.NODE_ENV !== 'production'
//     ? hot(FilterTagsComponent)
//     : FilterTagsComponent;
export const FilterTags = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterTagsComponent);

export default FilterTags;
